import { render } from "./PhotographerForm.vue?vue&type=template&id=b66442e8&scoped=true"
import script from "./PhotographerForm.vue?vue&type=script&lang=js"
export * from "./PhotographerForm.vue?vue&type=script&lang=js"

import "./PhotographerForm.vue?vue&type=style&index=0&id=b66442e8&lang=css&scoped=true"

import exportComponent from "D:\\xampp\\htdocs\\jump\\front\\jumpsa\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b66442e8"]])

export default __exports__